const error = {
  ADMIN_ONLY_OPERATION: 'Operación restringida de administrador',
  ARGUMENT_ERROR: 'Error de argumento',
  APP_NOT_AUTHORIZED: 'Aplicación no autorizada',
  APP_NOT_INSTALLED: 'Aplicación no instalada',
  CAPTCHA_CHECK_FAILED: 'Verificación de captcha fallida',
  CODE_EXPIRED: 'Código caducado',
  CORDOVA_NOT_READY: 'Cordova no esta lista',
  CORS_UNSUPPORTED: 'Cors no compatible',
  CREDENTIAL_ALREADY_IN_USE: 'Credencial ya en uso',
  CREDENTIAL_MISMATCH: 'Desajuste de token personalizado',
  CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'Requiere inicio de sesión reciente',
  DEPENDENT_SDK_INIT_BEFORE_AUTH: 'SDK dependiente inicializado antes de la autenticación',
  DYNAMIC_LINK_NOT_ACTIVATED: 'Enlace dinámico no activado',
  EMAIL_CHANGE_NEEDS_VERIFICATION: 'Cambio de correo electrónico necesita verificación',
  EMAIL_EXISTS: 'Correo electrónico ya en uso, inicie sesión en su lugar',
  EMULATOR_CONFIG_FAILED: 'Falló la configuración del emulador',
  EXPIRED_OOB_CODE: 'Código de acción caducado',
  EXPIRED_POPUP_REQUEST: 'Solicitud emergente cancelada',
  INTERNAL_ERROR: 'Error interno',
  INVALID_API_KEY: 'Clave API no válida',
  INVALID_APP_CREDENTIAL: 'Credencial de aplicación no válida',
  INVALID_APP_ID: 'Identificación de aplicación no válida',
  INVALID_AUTH: 'Token de usuario no válido',
  INVALID_AUTH_EVENT: 'Evento de autenticación no válido',
  INVALID_CERT_HASH: 'Hash de certificado no válido',
  INVALID_CODE: 'Código de verificación no válido',
  INVALID_CONTINUE_URI: 'URI de continuación no válido',
  INVALID_CORDOVA_CONFIGURATION: 'Configuración de cordova no válida',
  INVALID_CUSTOM_TOKEN: 'Token personalizado no válido',
  INVALID_DYNAMIC_LINK_DOMAIN: 'Dominio de enlace dinámico no válido',
  INVALID_EMAIL: 'Correo electrónico no válido',
  INVALID_EMULATOR_SCHEME: 'Esquema de emulador no válido',
  INVALID_IDP_RESPONSE: 'Credencial no válida',
  INVALID_MESSAGE_PAYLOAD: 'Carga de mensaje no válida',
  INVALID_MFA_SESSION: 'Sesión multifactor no válida',
  INVALID_OAUTH_CLIENT_ID: 'Id de cliente de autenticación no válido',
  INVALID_OAUTH_PROVIDER: 'Proveedor de autenticación no válido',
  INVALID_OOB_CODE: 'Código de acción no válido',
  INVALID_ORIGIN: 'Dominio no autorizado',
  INVALID_PASSWORD: 'Contraseña incorrecta',
  INVALID_PERSISTENCE: 'Tipo de persistencia no válido',
  INVALID_PHONE_NUMBER: 'Número de teléfono no válido',
  INVALID_PROVIDER_ID: 'ID de proveedor no válido',
  INVALID_RECIPIENT_EMAIL: 'Correo electrónico del destinatario no válido',
  INVALID_SENDER: 'Remitente no válido',
  INVALID_SESSION_INFO: 'Identificación de verificación no válida',
  INVALID_TENANT_ID: 'Identificación de inquilino no válida',
  MFA_INFO_NOT_FOUND: 'Información multifactorial no encontrada',
  MFA_REQUIRED: 'Autenticación multifactor requerida',
  MISSING_ANDROID_PACKAGE_NAME: 'Falta el nombre del paquete de Android',
  MISSING_APP_CREDENTIAL: 'Falta la credencial de la aplicación',
  MISSING_AUTH_DOMAIN: 'Se requiere configuración de dominio de autenticación',
  MISSING_CODE: 'Falta el código de verificación',
  MISSING_CONTINUE_URI: 'Falta continuar uri',
  MISSING_IFRAME_START: 'Falta el inicio del iframe',
  MISSING_IOS_BUNDLE_ID: 'Id de paquete de iOS faltante',
  MISSING_OR_INVALID_NONCE: 'Nonce faltante o no válido',
  MISSING_MFA_INFO: 'Falta información de múltiples factores',
  MISSING_MFA_SESSION: 'Falta sesión multifactor',
  MISSING_PHONE_NUMBER: 'Número de teléfono faltante',
  MISSING_SESSION_INFO: 'Id de verificación faltante',
  MODULE_DESTROYED: 'Aplicación eliminada',
  NECESIDAD_CONFIRMACIÓN: 'La cuenta existe con una credencial diferente',
  NETWORK_REQUEST_FAILED: 'Solicitud de red fallida',
  NULL_USER: 'Usuario nulo',
  NO_AUTH_EVENT: 'Sin evento de autenticación',
  NO_SUCH_PROVIDER: 'No hay tal proveedor',
  OPERATION_NOT_ALLOWED: 'Operación no permitida',
  OPERATION_NOT_SUPPORTED: 'Operación no admitida en este entorno',
  POPUP_BLOCKED: 'Ventana emergente bloqueada',
  POPUP_CLOSED_BY_USER: 'Ventana emergente cerrada por el usuario',
  PROVIDER_ALREADY_LINKED: 'Proveedor ya vinculado',
  QUOTA_EXCEEDED: 'Cuota excedida',
  REDIRECT_CANCELLED_BY_USER: 'Redireccionamiento cancelado por el usuario',
  REDIRECT_OPERATION_PENDING: 'Operación de redirección pendiente',
  REJECTED_CREDENTIAL: 'Credencial rechazada',
  SECOND_FACTOR_ALREADY_ENROLLED: 'Segundo factor ya en uso',
  SECOND_FACTOR_LIMIT_EXCEEDED: 'Recuento máximo de segundos factor excedido',
  TENANT_ID_MISMATCH: 'Id. de arrendatario no coincide',
  TIMEOUT: 'Tiempo de espera',
  TOKEN_EXPIRED: 'Token de usuario caducado',
  TOO_MANY_ATTEMPTS_TRY_LATER: 'Demasiadas solicitudes',
  UNAUTHORIZED_DOMAIN: 'URI de continuación no autorizado',
  UNSUPPORTED_FIRST_FACTOR: 'Primer factor no compatible',
  UNSUPPORTED_PERSISTENCE: 'Tipo de persistencia no admitido',
  UNSUPPORTED_TENANT_OPERATION: 'Operación de arrendatario no admitida',
  UNVERIFIED_EMAIL: 'Correo electrónico no verificado',
  USER_CANCELLED: 'Usuario cancelado',
  USER_DELETED: 'Usuario no encontrado',
  USER_DISABLED: 'Usuario deshabilitado',
  USER_MISMATCH: 'Usuario no coincidente',
  USER_SIGNED_OUT: 'Usuario cerrado',
  WEAK_PASSWORD: 'Contraseña débil',
  WEB_STORAGE_UNSUPPORTED: 'Almacenamiento web no compatible',
  ALREADY_INITIALIZED: 'Ya inicializado',
  USER_NOT_FOUND: 'Usuario no encontrado',
  NOT_IN_ORGANIZATION: 'Usuario no pertence a la organización',
  error_on_save: 'Error al guardar',
  select_must_one_student: 'Debe seleccionar al menos un estudiante',
  user_not_saved: 'No se pudo guardar el usuario',
};

export default error;
